import { createContext } from 'react'

interface ColorContextState {
  bg?: string
}

export const ColorContext = createContext<ColorContextState>({})
